// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"StagingTextSectionCitationDialog_modalTitle_1ztMQ","spinAround":"StagingTextSectionCitationDialog_spinAround_22XSr"};